import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/golf-park-slider-2.jpg")